<template>
  <Category cate-name="business" category-name="ビジネス" />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
